import { BannerType } from '@entities/BannerPage/module/types/bannerSchema';

export const BannerTyresSummer: BannerType = {
  href: '/actions/vse-super-aktsii-v-odnom-klike/',
  imageDesktop: 'https://koleso.ru/upload/medialibrary/banners/13_3092.jpg',
  imageMobile: 'https://koleso.ru/upload/medialibrary/banners/13_3093.jpg',
  name: 'Шины с бесплатным шиномонтажом',
  erid: '2W5zFHhw8PS',
  options: {
    widthDesktop: 3420,
    widthMobile: 1268,
    heightDesktop: 450,
    heightMobile: 828,
  },
};

export const BannerTyresSummerKrsk: BannerType = {
  href: '/actions/skidka-10_-na-letnie-shinyi/',
  imageDesktop: 'https://koleso.ru/upload/medialibrary/banners/13_3099.jpg',
  imageMobile: 'https://koleso.ru/upload/medialibrary/banners/13_3100.jpg',
  name: 'Скидка 10% на летние шины!',
  erid: '2W5zFJkN9Kv',
  options: {
    widthDesktop: 2280,
    widthMobile: 1268,
    heightDesktop: 300,
    heightMobile: 828,
  },
};

export const BannerTyresWinter: BannerType = {
  href: '/actions/gotov-shinyi-letom-hranenie-i-montaj-besplatno/',
  imageDesktop: 'https://koleso.ru/upload/medialibrary/banners/13_3129.jpg',
  imageMobile: 'https://koleso.ru/themes/tireshop2/images/actions/8c22d759816107e20d4eda0d714cbda4.png',
  name: 'Готовь шины летом!',
  erid: '2W5zFGKUzhv',
  options: {
    widthDesktop: 2280,
    widthMobile: 634,
    heightDesktop: 300,
    heightMobile: 414,
  },
};

export const BannerTyresWinterAction: BannerType = {
  href: null,
  imageDesktop: 'https://koleso.ru/upload/medialibrary/banners/13_3129.jpg',
  imageMobile: 'https://koleso.ru/themes/tireshop2/images/actions/8c22d759816107e20d4eda0d714cbda4.png',
  name: 'Готовь шины летом!',
  erid: '2W5zFGKUzhv',
  options: {
    widthDesktop: 2280,
    widthMobile: 634,
    heightDesktop: 300,
    heightMobile: 414,
  },
};

export const BannerTyres: BannerType = {
  href: '/actions/shinyi-s-besplatnyim-shinomontajom-v-pvz/',
  imageDesktop: 'https://koleso.ru/upload/medialibrary/banneryi-na-kartochkah-tovara/14_2547.jpeg',
  imageMobile: 'https://koleso.ru/upload/medialibrary/banneryi-na-kartochkah-tovara/14_2546.jpeg',
  name: 'Купите шины сейчас, зафиксируйте свою выгоду!',
  options: {
    widthDesktop: 1140,
    widthMobile: 634,
    heightDesktop: 130,
    heightMobile: 414,
  },
};

export const BannerOils: BannerType = {
  href: '/actions/zamena-masla-v-podarok-1l/',
  imageDesktop: 'https://koleso.ru/upload/medialibrary/banners/13_2306.jpg',
  imageMobile: 'https://koleso.ru/upload/medialibrary/banners/13_2305.jpg',
  name: 'Бесплатная замена масла в сети КОЛЕСО.ру',
  options: {
    widthDesktop: 1440,
    widthMobile: 576,
    heightDesktop: 126,
    heightMobile: 230,
  },
};

export const BannerTruckTyresKama: BannerType = {
  href: null,
  imageDesktop: 'https://koleso.ru/upload/medialibrary/banners/13_2252.jfif',
  imageMobile: 'https://koleso.ru/upload/medialibrary/banners/13_2253.jfif',
  name: null,
  options: {
    widthDesktop: 1440,
    widthMobile: 634,
    heightDesktop: 126,
    heightMobile: 414,
  },
};

export const BannerTyresKama: BannerType = {
  href: null,
  imageDesktop: 'https://koleso.ru/upload/medialibrary/banners/13_2281.jpg',
  imageMobile: 'https://koleso.ru/upload/medialibrary/banners/13_2279.jpg',
  name: null,
  options: {
    widthDesktop: 1440,
    widthMobile: 634,
    heightDesktop: 126,
    heightMobile: 414,
  },
};

export const BannerTyresCordiant: BannerType = {
  href: null,
  imageDesktop: 'https://koleso.ru/upload/medialibrary/banners/13_2821.jpg',
  imageMobile: 'https://koleso.ru/upload/medialibrary/banners/13_2820.jpg',
  name: null,
  options: {
    widthDesktop: 1440,
    widthMobile: 634,
    heightDesktop: 126,
    heightMobile: 414,
  },
};

export const BannerTyresViatti: BannerType = {
  href: null,
  imageDesktop: 'https://koleso.ru/upload/medialibrary/banners/13_2823.jpg',
  imageMobile: 'https://koleso.ru/upload/medialibrary/banners/13_2822.jpg',
  name: null,
  options: {
    widthDesktop: 1440,
    widthMobile: 634,
    heightDesktop: 126,
    heightMobile: 414,
  },
};

export const BannerTyresPirelli: BannerType = {
  href: '/actions/pirelli_tyres_konkurs/',
  imageDesktop: 'https://koleso.ru/upload/medialibrary/banners/13_2975.jpg',
  imageMobile: 'https://koleso.ru/upload/medialibrary/banners/13_2974.jpg',
  name: 'Оставляйте отзыв и участвуйте в розыгрыше зимних шин PIRELLI!',
  options: {
    widthDesktop: 1440,
    widthMobile: 634,
    heightDesktop: 126,
    heightMobile: 414,
  },
};

export const BannerTyresNokian: BannerType = {
  href: '/catalog/tyres/ikontyres/',
  imageDesktop: 'https://koleso.ru/articles/wp-content/uploads/2024/03/Новое-имя-NOKIAN-IKON_1140х60.jpg',
  imageMobile: 'https://koleso.ru/articles/wp-content/uploads/2024/03/Новое-имя-NOKIAN-IKON_634х88.jpg',
  name: 'Оставляйте отзыв и участвуйте в розыгрыше зимних шин PIRELLI!',
  options: {
    widthDesktop: 1440,
    widthMobile: 634,
    heightDesktop: 75,
    heightMobile: 88,
  },
};

export const BannerTyresLandsail: BannerType = {
  href: '',
  imageDesktop: 'https://koleso.ru/articles/wp-content/uploads/2024/03/Десктоп-2.jpg',
  imageMobile: 'https://koleso.ru/articles/wp-content/uploads/2024/03/Мобильная-версия-2.jpg',
  name: 'Оставляйте отзыв и участвуйте в розыгрыше зимних шин PIRELLI!',
  options: {
    widthDesktop: 1440,
    widthMobile: 576,
    heightDesktop: 126,
    heightMobile: 230,
  },
};

export const BannerAlloyDisks: BannerType = {
  href: '/actions/rasprodaja-do-60_-na-lityie-diski-msk/',
  imageDesktop: 'https://koleso.ru/upload/medialibrary/banners/13_3097.jpg',
  imageMobile: 'https://koleso.ru/upload/medialibrary/banners/13_3098.jpg',
  name: 'Распродажа до 60% на литые диски',
  erid: '2W5zFFzTa5N',
  options: {
    widthDesktop: 3420,
    widthMobile: 1268,
    heightDesktop: 450,
    heightMobile: 828,
  },
};
